export default "__VITE_ASSET__MT5M38jQ__"